const menuData = {
  heading: "Menu",
  links: [
    {
      route: "/about",
      textContent: "About Us",
      externalLink: false,
    },
    {
      route: "/categories",
      textContent: "Categories",
      externalLink: false,
    },
    {
      route: "/search",
      textContent: "Search",
      externalLink: false,
    },
  ],
};
const termsData = {
  heading: "Terms",
  links: [
    {
      route: "/terms/#privacy-policy",
      textContent: "Privacy Policy",
      externalLink: false,
    },
    {
      route: "/terms/#cookie-policy",
      textContent: "Cookie Policy",
      externalLink: false,
    },
    {
      route: "/terms",
      textContent: "Terms of Service",
      externalLink: false,
    },
  ],
};
// const socialMedia = {
//   heading: "Social Media",
//   links: [
//     {
//       route: "/about",
//       textContent: "Instagram",
//       externalLink: true,
//     },
//     {
//       route: "/categories",
//       textContent: "Facebook",
//       externalLink: true,
//     },
//     {
//       route: "/search",
//       textContent: "Search",
//       externalLink: true,
//     },
//   ],
// };
const footerData = [
    menuData,
    termsData,
//    socialMedia
];

export default footerData